import 'vidstack/player';
import 'vidstack/player/layouts/default';
import 'vidstack/player/ui';
import 'vidstack/player/styles/base.css';
import 'vidstack/player/styles/plyr/theme.css';

import { defineCustomElement, MediaPlyrLayoutElement } from "vidstack/elements";
defineCustomElement(MediaPlyrLayoutElement);